<!--
 * @Author: hongqi
 * @LastEditors: hongqi
 * @Date: 2021-01-06 17:12:19
 * @LastEditTime: 2021-01-06 18:29:32
-->
<template>
    <div>
        <div class="contact">
            <img class="contact-img" src="../../assets/images/contactOffline_icon.png">
            <div class="flex">
                <div class="contact-tit">联系客服</div>
                <div class="contact-intro">使用过程中有任何问题可以联系客服热线，我们将竭诚为您服务</div>
            </div>
        </div>
        <div class="contact-item">
            <div class="wx-tit">微信咨询1</div>
            <img class="wx" :src="info.kehu1" alt="" @click="previewImage(info.kehu1)">
        </div>
        <div class="contact-item">
            <div class="wx-tit">微信咨询2</div>
            <img class="wx" :src="info.kehu2" alt="" @click="previewImage(info.kehu2)">
        </div>
        <a class="contact-item" :href="'tel:'+info.zixun1_mobile">
            <div class="wx-tit">咨询电话1</div>
            <div class="phone">{{info.zixun1_mobile}}</div>
            <img src="../../assets/images/right_arrow_icon.png" class="right-arrow" alt="">
        </a>
        <a class="contact-item" :href="'tel:'+info.zixun2_mobile">
            <div class="wx-tit">咨询电话2</div>
            <div class="phone">{{info.zixun2_mobile}}</div>
            <img src="../../assets/images/right_arrow_icon.png" alt="" class="right-arrow">
        </a>
    </div>

</template>

<script>
import { ImagePreview } from 'vant';
import {customerService} from '@api/user'
export default {
    data() {
        return {
            info:{}
        }
    },
    mounted() {
        this.getInfo()
    },
    methods: {
        previewImage(img) {
            ImagePreview([
                img
            ]);
        },
        getInfo() {
            customerService().then(res=>{
                console.log(res)
                this.info = res.data;
            })
        },
    },
};
</script>

<style lang="scss" scoped>
.contact-item {
    height: 1.26rem;
    margin: 0.1rem 0.22rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.22rem;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 0.1rem;
    .wx-tit {
        font-size: 0.32rem;
        color: #333333;
    }
    .wx {
        width: 0.6rem;
        height: 0.6rem;
        object-fit: contain;
    }
    .phone{
color: #D01112;
        font-size: .32rem;
        flex: 1;
        margin-right: .2rem;
        text-align: right;
    }
    .right-arrow{
        width: .14rem;
        height: .24rem;
    }
}
.contact {
    height: 6.14rem;
    margin: 0.5rem 0.2rem 0;
    background: #fff;
    border-radius: 0.1rem;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 0.02rem 0.3rem 0px rgba(157, 157, 157, 0.2);
    .contact-img {
        width: 100%;
        height: 3.32rem;
        object-fit: contain;
    }
    .flex {
        flex: 1;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 0.9rem;
        box-sizing: border-box;
        .contact-intro {
            text-align: center;
            font-size: 0.28rem;
            color: #999999;
            margin-top: 0.26rem;
        }
        .contact-tit {
            font-size: 0.36rem;
            color: #333333;
        }
    }
}
</style>
